import React from "react";
import { harmonyRingEnabled } from "src/config/config";
import { Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import { ForgetPassword, Programmes, ProgrammesDetail } from "./pages/index";
import Login from "./pages/Login";
import DashboardApp from "./pages/DashboardApp";
import ClientReviews from "./pages/ClientReviews/ClientReviews";
import AddProgramReview from "./pages/ReviewCard/AddProgramReview";
import DeleteProgram from "./components/_dashboard/programmes/Deleteprogram";
import EditProgramReview from "./pages/ReviewCard/EditReview";
import EditProfile from "./pages/Profile/EditProfile";
import Calenders from "./pages/Calender/Calender";
import ExercisListing from "./pages/Exercises/ExercisListing";
import AddExercise from "./pages/Exercises/AddExercise";
import EditExercise from "./pages/Exercises/EditExercise";
import ExerciseDetail from "./pages/Exercises/ExerciseDetail";
import ExercisListingType from "./pages/ExercisesType/ExercisListingType";
import AddExerciseType from "./pages/ExercisesType/AddExerciseType";
import EditExerciseType from "./pages/ExercisesType/EditExerciseType";
import WorkoutDetail from "./pages/Workout/WorkoutDetail";
import AddFormTemplate from "./pages/UserFormTemplate/addFormTemplate";
import EditFormTemplate from "./pages/UserFormTemplate/editFormTemplate";
import TemplatePreview from "./pages/UserFormTemplate/templatePreview";
import FormTemplates from "./pages/UserFormTemplate/FormTemplates";
import UserForm from "./pages/UserForms/UserForm";
import AddForm from "./pages/UserForms/AddForm";
import DetailsFormInformation from "./pages/UserForms/DetailsFormInformation";
import EditForm from "./pages/UserForms/EditForm";
import CoachForms from "./pages/UserInformation/CoachForms";
import DetailsCoachFormInformation from "./pages/UserInformation/DetailsCoachFormInformation";
import CoachInformationform from "./pages/UserInformation/CoachInformationform";
import AddWorkout from "./pages/Workout/AddWorkoutNew";
import EditWorkout from "./pages/Workout/EditWorkoutNew";
import AddProgramme from "./pages/Programmes/AddProgramme";
import EditProgramme from "./pages/Programmes/EditProgramme";
import ProgrammeBulkAccess from "./components/ProgrammBulkAccess/ProgrammeBulkAccess";
import DynamicTable from "./pages/Calender/component/FixedCalender";
import MembersList from "./pages/Members/MembersList";
import AddMember from "./pages/Members/AddMember";
import EditMember from "./pages/Members/EditMember";
import ListUserForm from "./pages/Members/UserForms/ListUserForm";
import MemberProfile from "./pages/Members/MemberProfile";
import MemberCalendar from "./pages/Members/MemberCalendar";
import WorkoutEditFullPage from "./pages/Members/WorkoutEditFullPage";
import ClientVideos from "./pages/HelpingVideos/ClientVideos";
import ClientVideoDetail from "./pages/HelpingVideos/ClientVideoDetail";
import HelpingVideos from "./pages/HelpingVideos/HelpingVideos";
import HelpingVideoDetail from "./pages/HelpingVideos/HelpingVideoDetail";
import ProgramUsersForm from "./pages/Programmes/UserForms";
import WorkoutDisplay from "./pages/Banner/WorkoutDisplay";
import Feed from "./pages/CommunityFeeds/Feed";
import PendingPosts from "./pages/CommunityFeeds/PendingPosts";
import RejectedPosts from "./pages/CommunityFeeds/RejectedPosts";
import GroupsFeedsDetail from "./pages/CommunityFeeds/GroupsFeedsDetail";
import GroupMembers from "./pages/GroupsFeeds/GroupMembers";
import AddGroupsFeed from "./pages/GroupsFeeds/AddGroupsFeed";
import EditGroupFeed from "./pages/GroupsFeeds/EditGroupFeed";
import GroupsFeed from "./pages/GroupsFeeds/GroupsFeed";
import MyPosts from "./pages/CommunityFeeds/MyPosts";
import UserFormAgainstProgram from "./pages/UserForms/Components/UserFormAgainstProgram";
import PostDetail from "./pages/CommunityFeeds/PostDetail";
import FeedDetailPage from "./pages/CommunityFeeds/FeedDetailPage";
import ChangePassword from "./pages/Members/ChangePassword";
import AddfoodMatters from "./pages/FoodMattersLibrary/AddfoodMatters";
import EditFoodMatters from "./pages/FoodMattersLibrary/EditFoodMatters";
import AddMindset from "./pages/MindSetLibrary/AddMindset";
import EditMindset from "./pages/MindSetLibrary/EditMindset";
import RecentPointsTable from "./pages/Members/RecentPointsTable";
import LoginByAdmin from "./pages/LoginByAdmin";
import AddAdminCategory from "./pages/HelpingVideos/AddAdminCategory";
import EditAdminVideosCategory from "./pages/HelpingVideos/EditAdminVideosCategory";
import AdminVideosCatagories from "./pages/HelpingVideos/AdminVideosCatagories";
import HelpingVideosCategory from "./pages/HelpingVideos/HelpingVideosCategory";
import AddVideoSet from "./pages/VideoLibrary/AddVideoSet";
import EditVideoSet from "./pages/VideoLibrary/EditVideoSet";
import Chat from "./pages/Chat/Chat";
import MainUserFormList from "./pages/UserForms/MainUserFormList";
import UserFormMembers from "./pages/UserForms/UserFormMembers";
import CalendarEvents from "./pages/MyCalender/CalendarEvents";
import SupportTicket from "./pages/SupportTickets/SupportTicket";
import SupportTicketDetail from "./pages/SupportTickets/SupportTicketDetail";
import AddOrEditFood from "./pages/Food/AddOrEditFood";
import FoodList from "./pages/Food/FoodList";
import WeightTracker from "./pages/Members/WeightTracker";
import ProgrammesFolder from "./pages/Programmes/ProgrammesFolder";
import AddOrUpdateFolder from "./pages/Programmes/AddOrUpdateFolder";
import AddWorkBook from "./pages/MindSetLibrary/AddWorkBook";
import EditWorkBook from "./pages/MindSetLibrary/EditWorkBook";
import HarmonyProgram from "./pages/HarmonyProgram";
import MemberChartInfo from "./pages/Programmes/MemberChartInfo";
import GeneralListing from "./pages/GeneralLibraryType/GeneralListing";
import GeneralListingType from "./pages/GeneralLibraryType/GeneralListingType";
import AddCommentSet from "./pages/CommentLibrary/AddCommentSet";
import EditCommentSet from "./pages/CommentLibrary/EditCommentSet";
import TrackersList from "./pages/Trackers/TrackersList";
import TrackerDetailPage from "./pages/Trackers/TrackerDetailPage";
import TrackerSubmissionsList from "./pages/Trackers/TrackerSubmissionsList";
import TrackerSubmissionDetailPage from "./pages/Trackers/TrackerSubmissionDetailPage";
import TrackerReviewsListPage from "./pages/Trackers/TrackerReviewsListPage";
import TrackerReviewDetailPage from "./pages/Trackers/TrackerReviewDetailPage";
import TrackerAutomationsList from "./pages/Trackers/automations/TrackerAutomationsList";
import AutomationBuilderPage from "./pages/Trackers/automationBuilder/AutomationBuilderPage";
// Coach workspace (Nov 2026) — new screens on new paths; old pages unchanged.
import CoachTodayPage from "./pages/CoachWorkspace/CoachTodayPage";
import CoachClientsPage from "./pages/CoachWorkspace/CoachClientsPage";
import ClientWorkspacePage from "./pages/CoachWorkspace/ClientWorkspacePage";
import ClientReviewPage from "./pages/CoachWorkspace/ClientReviewPage";
import WeeklyPlannerPage from "./pages/CoachWorkspace/WeeklyPlannerPage";
import CoachQuestionsPage from "./pages/CoachWorkspace/CoachQuestionsPage";
import FeedbackPage from "./pages/CoachWorkspace/FeedbackPage";

// ----------------------------------------------------------------------
// TODAY-HOME (3 Nov): an already signed-in coach opening the portal ("/")
// lands on Today; team logins (no Today) keep the old dashboard. The sidebar
// "Dashboard" item still opens the old dashboard.
const homeForStoredUser = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user_data") || "{}");
    return user?.team_type === "team" ? "/dashboard" : "/coach/today";
  } catch (e) {
    return "/dashboard";
  }
};
const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to={homeForStoredUser()}> </Navigate>;
  }
  if (!localStorage.getItem("token")) {
    return <Navigate to="/login"> </Navigate>;
  }
};
export default function Router() {
  return (
    <Routes>
      <Route
        path="/member/:id/workout-edit/:CalId/:workoutId"
        element={<WorkoutEditFullPage />}
      />
      <Route path="/login-by-admin/:token" element={<LoginByAdmin />} />
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/dashboard" element={<DashboardApp />} />
        <Route path="/client-reviews" element={<ClientReviews />} />
        {harmonyRingEnabled && (
          <>
            <Route
              path="/dashboard/harmony-program/:program_id"
              element={<HarmonyProgram />}
            />
            <Route
              path="/dashboard/harmony-program/:id/:CalId"
              element={<MemberChartInfo />}
            />{" "}
            <Route
              path="/member/:id/member-MemberCalendar/:CalId/graph"
              element={<MemberChartInfo />}
            />
          </>
        )}
        <Route path="/coach_forms" element={<CoachForms />} />
        <Route
          path="/coach_forms-submition/:slug"
          element={<CoachInformationform />}
        />
        <Route
          path="/coach_forms-Details/:slug/:user_id"
          element={<DetailsCoachFormInformation />}
        />
        <Route path="/form-list" element={<MainUserFormList />} />
        <Route path="/form-list/forms-send-forms" element={<AddForm />} />
        <Route
          path="/form-list/forms-edit-forms/:slug"
          element={<EditForm />}
        />
        <Route path="/form-list/forms/:id" element={<UserForm />} />
        <Route
          path="/form-list/forms/forms-preview/:slug"
          element={<DetailsFormInformation page_type="forms" />}
        />
        <Route
          path="/form-list/forms/members/:id"
          element={<UserFormMembers />}
        />
        <Route
          path="/form-list/forms/members/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/members/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/programmes/members/:id"
          element={<UserFormMembers type="programmes" />}
        />
        <Route
          path="/programmes/members/forms-preview/:slug/:user_id"
          element={<DetailsFormInformation page_type="members_forms" />}
        />
        <Route
          path="/mindset_type"
          element={<GeneralListingType type="mindset" />}
        />
        <Route
          path="/nutrition_type"
          element={<GeneralListingType type="food" />}
        />
        <Route
          path="/video_type"
          element={<GeneralListingType type="video" />}
        />
        <Route
          path="/comment_type"
          element={<GeneralListingType type="comment" />}
        />
        <Route
          path="/workout_type"
          element={<GeneralListingType type="workout" />}
        />
        <Route
          path="/nutrition_library"
          element={<GeneralListing type="food" />}
        />
        <Route
          path="/workout_library"
          element={<GeneralListing type="workout" />}
        />{" "}
        <Route
          path="/mindset_library"
          element={<GeneralListing type="mindset" />}
        />
        <Route
          path="/video_library"
          element={<GeneralListing type="video" />}
        />{" "}
        <Route
          path="/comment_library"
          element={<GeneralListing type="comment" />}
        />
        <Route
          path="/workbook_library"
          element={<GeneralListing type="workbook" />}
        />
        <Route path="/trackers" element={<TrackersList />} />
        <Route path="/trackers/:id" element={<TrackerDetailPage />} />
        <Route
          path="/tracker-submissions"
          element={<TrackerSubmissionsList />}
        />
        <Route
          path="/tracker-submissions/:id"
          element={<TrackerSubmissionDetailPage />}
        />
        <Route path="/tracker-reviews" element={<TrackerReviewsListPage />} />
        <Route
          path="/tracker-reviews/:id"
          element={<TrackerReviewDetailPage />}
        />
        <Route path="/tracker-automations" element={<TrackerAutomationsList />} />
        <Route
          path="/tracker-automation-builder/new"
          element={<AutomationBuilderPage />}
        />
        <Route
          path="/tracker-automation-builder/:id"
          element={<AutomationBuilderPage />}
        />
        {/* Coach workspace — new paths (see COACH_WORKSPACE_CHANGES.md) */}
        <Route path="/coach/today" element={<CoachTodayPage />} />
        <Route path="/coach/clients" element={<CoachClientsPage />} />
        <Route path="/coach/clients/:clientKey" element={<ClientWorkspacePage />} />
        <Route path="/coach/review/:submissionId" element={<ClientReviewPage />} />
        <Route path="/coach/review/:submissionId/feedback" element={<FeedbackPage />} />
        <Route path="/coach/check-ins/planner" element={<WeeklyPlannerPage />} />
        <Route path="/coach/check-ins/questions" element={<CoachQuestionsPage />} />
        <Route path="/coach/check-ins/:trackerId/questions" element={<CoachQuestionsPage />} />
        <Route
          path="/user_form-templates/add-user_form-templates"
          element={<AddFormTemplate />}
        />
        <Route
          path="/user_form-templates/edit-user_form-templates/:id"
          element={<EditFormTemplate />}
        />
        <Route
          path="/user_form-templates/preview-user_form-templates/:id"
          element={<TemplatePreview />}
        />
        <Route path="/user_form-templates" element={<FormTemplates />} />
        <Route path="/forms" element={<UserForm />} />
        <Route path="/calendar-events" element={<CalendarEvents />} />
        <Route path="/forms/forms-send-forms" element={<AddForm />} />
        <Route
          path="/forms-preview/:slug"
          element={<DetailsFormInformation />}
        />
        <Route
          path="/forms/:fId/template/:tId/program/:id"
          element={<UserFormAgainstProgram />}
        />
        <Route
          path="/programmes/forms/:fId/template/:tId/program/:id"
          element={<UserFormAgainstProgram />}
        />
        <Route path="/forms/forms-edit-forms/:slug" element={<EditForm />} />
        <Route path="/exercise" element={<ExercisListing />} />
        <Route path="/exercise-add" element={<AddExercise />} />
        <Route path="/exercise-edit/:slug" element={<EditExercise />} />
        <Route path="/exercise-details/:slug" element={<ExerciseDetail />} />
        <Route path="/type-exercise" element={<ExercisListingType />} />
        <Route path="/type-exercise-add" element={<AddExerciseType />} />
        <Route
          path="/type-exercise-edit/:slug"
          element={<EditExerciseType />}
        />
        <Route path="/workout-add" element={<AddWorkout />} />
        <Route path="/workout-edit/:slug" element={<EditWorkout />} />
        <Route path="/workout-details/:slug" element={<WorkoutDetail />} />
        <Route path="/food_matters-add" element={<AddfoodMatters />} />
        <Route path="/food_matters-edit/:slug" element={<EditFoodMatters />} />
        <Route path="/food" element={<FoodList />} />
        <Route path="/food/add-food" element={<AddOrEditFood />} />
        <Route path="/food/edit-food/:food_id" element={<AddOrEditFood />} />
        <Route path="/mindset-add" element={<AddMindset />} />
        <Route path="/mindset-edit/:slug" element={<EditMindset />} />
        <Route path="/videoset-add" element={<AddVideoSet />} />
        <Route path="/videoset-edit/:slug" element={<EditVideoSet />} />
        <Route path="/commentset-add" element={<AddCommentSet />} />
        <Route path="/commentset-edit/:slug" element={<EditCommentSet />} />
        <Route path="/workbook-add" element={<AddWorkBook />} />
        <Route path="/workbook-edit/:slug" element={<EditWorkBook />} />
        <Route
          path="/programmes/:folder_id"
          element={<Programmes type="active" />}
        />
        <Route path="/programmes-folder" element={<ProgrammesFolder />} />
        <Route
          path="/programmes-folder/add-folder"
          element={<AddOrUpdateFolder />}
        />{" "}
        <Route
          path="/programmes-folder/edit-folder/:folder_id"
          element={<AddOrUpdateFolder />}
        />
        <Route
          path="/inactive-programmes"
          element={<Programmes type="inactive" />}
        />
        <Route
          path="/programmes/programmes-form/:id"
          element={<ProgramUsersForm />}
        />
        <Route
          path="/programmes/programmes-form/forms-preview/:slug"
          element={<DetailsFormInformation page_type="forms" />}
        />
        <Route path="/Editprofile" element={<EditProfile />} />
        <Route path="/members" element={<MembersList />} />
        <Route
          path="/member/change-password/:id"
          element={<ChangePassword />}
        />
        <Route path="/member/edit-member/:id" element={<EditMember />} />
        <Route path="/member/weight-tracker/:id" element={<WeightTracker />} />
        <Route path="/member/add-member" element={<AddMember />} />
        <Route
          path="/members/List-forms/:id/form/:slug"
          element={<DetailsFormInformation />}
        />
        <Route
          path="/programmes/forms-preview/:slug"
          element={<DetailsFormInformation />}
        />
        <Route
          path="/members/List-forms/:id"
          element={<ListUserForm type="members" />}
        />
        <Route path="/member/member-profile/:id" element={<MemberProfile />} />
        <Route
          path="/member/member-points/:id"
          element={<RecentPointsTable />}
        />
        <Route
          path="/member/:id/member-MemberCalendar/:CalId"
          element={<MemberCalendar />}
        />
        <Route path="/members/profile/:id" element={<MemberProfile />} />
        <Route
          path="/programmes/deleteProgram/:slug"
          element={<DeleteProgram />}
        />
        <Route
          path="/programmes/addReview/:slug"
          element={<AddProgramReview />}
        />
        <Route
          path="/programmes/editProgrammeReview/:programSlug/:reviewSlug"
          element={<EditProgramReview />}
        />
        <Route
          path="/programmes/edit-programme/:programme_slug"
          element={<EditProgramme />}
        />
        <Route path="/programmes/:type/:id" element={<ProgrammeBulkAccess />} />
        <Route
          path="/programmes/programmes-detail/:id"
          element={<ProgrammesDetail />}
        />
        <Route path="/programmes-calendar/:id/:slug" element={<Calenders />} />
        <Route path="/chat" element={<Chat />} />
        <Route
          path="/programmes-limited-calendar/:id/:slug"
          element={<DynamicTable />}
        />
        <Route
          path="/programmes/add-programme/:folder_id"
          element={<AddProgramme />}
        />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/support-ticket/:id" element={<SupportTicketDetail />} />
        <Route
          path="/members_videos_category/members-videos/:id"
          element={<ClientVideos />}
        />
        <Route
          path="/members_videos_category/add"
          element={<AddAdminCategory />}
        />
        <Route
          path="/members_videos_category/edit/:id"
          element={<EditAdminVideosCategory />}
        />
        <Route
          path="/members_videos_category"
          element={<AdminVideosCatagories />}
        />
        <Route
          path="/helping_videos_category"
          element={<HelpingVideosCategory />}
        />
        <Route
          path="/members-videos/members-videos-detail/:id"
          element={<ClientVideoDetail />}
        />
        <Route
          path="/helping_videos_category/helping-videos/:id"
          element={<HelpingVideos />}
        />
        <Route
          path="/helping_videos_category/:id/helping-videos/:slug"
          element={<HelpingVideoDetail />}
        />
        <Route path="/community-area" element={<Feed />} />
        <Route path="/pending-posts" element={<PendingPosts />} />
        <Route path="/rejected-posts" element={<RejectedPosts />} />
        <Route path="/pending-posts/post-detail" element={<PostDetail />} />
        <Route path="/rejected-posts/post-detail" element={<PostDetail />} />
        <Route
          path="/community-area-post-detail/:id"
          element={<FeedDetailPage />}
        />
        <Route path="/feed-groups" element={<GroupsFeed />} />
        <Route path="/feed-groups/add-group" element={<AddGroupsFeed />} />
        <Route
          path="/feed-groups/edit-group/:slug"
          element={<EditGroupFeed />}
        />
        <Route path="/groups/group-members/:slug" element={<GroupMembers />} />
        <Route
          path="/community-area/groups/group-members/:slug"
          element={<GroupMembers />}
        />
        <Route path="/group-feed/:id" element={<GroupsFeedsDetail />} />
        <Route path="/my-posts" element={<MyPosts />} />
        <Route path="*" element={<Authentication />} />
      </Route>

      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget_password" element={<ForgetPassword />} />
        <Route path="/WorkoutDisplay" element={<WorkoutDisplay />} />
        <Route path="*" element={<Authentication />} />
      </Route>
    </Routes>
  );
}
